import { render, staticRenderFns } from "./ListagemVueComponenteMenuComponent.vue?vue&type=template&id=1de457b2"
import script from "./ListagemVueComponenteMenuComponent.vue?vue&type=script&lang=js"
export * from "./ListagemVueComponenteMenuComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports